import { lotCodeType } from "../type";
import { getLotListApi,} from "../../api/pricingChart.api";

export const lotCodeListAction =
  (SubareaId, RawMaterialSuid, rmId) => async (dispatch) => {
   
    try {
      const { data } = await getLotListApi({ SubareaId, RawMaterialSuid, rmId });
  
      const lotCode = data.data?.map((state) => ({
        label: state,
        value: state,
      }));

      const actionTypes = {
        ERM1: lotCodeType.PRICE_CHART_LOTCODE_DIAMOND,
        ERM2: lotCodeType.PRICE_CHART_LOTCODE_PRECIOUS,
        ERM3: lotCodeType.PRICE_CHART_LOTCODE_SEMI_PRECIOUS,
        ERM8: lotCodeType.PRICE_CHART_LOTCODE_CHAIN,
        ERM7: lotCodeType.PRICE_CHART_LOTCODE_FINDING,
      };

      const actionType = actionTypes[RawMaterialSuid];

      if (actionType) {
        dispatch({
          type: actionType,
          payload: lotCode,
        });
      } else {
        dispatch({
          type: lotCodeType.PRICING_CHART_ERROR,
          payload: "Invalid RawMaterialSuid",
        });
      }
    } catch (error) {
      // console.log(error);

      dispatch({
        type: lotCodeType.PRICING_CHART_ERROR,
        payload: error,
      });
    }
  };
 

// export const lotCodeInsertAction = (lotCode,RawMaterialSuid) => async (dispatch) => {
//   try {
//     const { data } = await getLotCodeInsert({lotCode, RawMaterialSuid});
    
//     dispatch({
//       type: lotCodeType.PRICE_CHART_LOTCODE_INSERT,
//       payload: data.data,
//       RawMaterialSuid
//     });
//   } catch (error) {
//     // console.log(error);

//     dispatch({
//       type: lotCodeType.PRICING_CHART_ERROR,
//       payload: error,
//     });
//   }
// };
